import { useTenantTranslation, useUnitsFormatter } from "hooks/formatters";
import { useIsMobile } from "hooks/useIsMobile";
import { ScrapHeader } from "../common/ScrapHeader";
import {
  Measure,
  useIsStatic,
  useMeasureOption,
  usePeriodOption,
} from "./ProductionContext";

interface Props {
  rowId:
    | "total_mass"
    | "total_price"
    | "materials_price"
    | "electrical_energy_price"
    | "charged_price"
    | number;
  id: number;
  name: string;
}

export const ScrapRowHeader = ({ rowId, name, id }: Props) => {
  const unit = useUnitsFormatter(true);
  const { t } = useTenantTranslation();
  const measureOption = useMeasureOption();
  const period = usePeriodOption();
  const isMobile = useIsMobile();
  const isStatic = useIsStatic();
  const massUnit = measureOption === Measure.SmallMass ? "small_mass" : "mass";

  switch (rowId) {
    case "total_mass": {
      return (
        <ScrapHeader
          type="static"
          renderValue={
            isMobile ? t("totalMass") : `${t("totalMass")}${unit(massUnit)}`
          }
        />
      );
    }
    case "materials_price": {
      return (
        <ScrapHeader
          type="static"
          renderValue={
            isMobile
              ? t("materialsTappedPrice")
              : `${t("materialsTappedPrice")}${unit("specific_cost")}`
          }
        />
      );
    }
    case "electrical_energy_price": {
      return (
        <ScrapHeader
          type="static"
          renderValue={
            isMobile
              ? t("electricalEnergyTappedPrice")
              : `${t("electricalEnergyTappedPrice")}${unit("specific_cost")}`
          }
        />
      );
    }
    case "total_price": {
      return (
        <ScrapHeader
          type="static"
          renderValue={
            isMobile
              ? t("tappedPrice")
              : `${t("tappedPrice")}${unit("specific_cost")}`
          }
        />
      );
    }
    case "charged_price": {
      return (
        <ScrapHeader
          type="static"
          renderValue={
            isMobile
              ? t("chargedPrice")
              : `${t("chargedPrice")}${unit("specific_cost")}`
          }
        />
      );
    }
    default: {
      const nameSuffix = isMobile
        ? ""
        : (() => {
            switch (measureOption) {
              case Measure.Mass:
                return unit("mass");
              case Measure.Percentage:
                return unit("mass_fraction");
              case Measure.SmallMass:
                return unit("small_mass");
            }
          })();

      if (isStatic) {
        return (
          <ScrapHeader type="static" renderValue={`${name}${nameSuffix}`} />
        );
      }

      const scrapHeaderType = (() => {
        switch (period) {
          case 1:
            return "consumption";
          default:
            return "properties";
        }
      })();

      return (
        <ScrapHeader
          type={scrapHeaderType}
          renderValue={`${name}${nameSuffix}`}
          name={name}
          id={id}
          alignment="left"
          period={period}
        />
      );
    }
  }
};
